import { getAppRedirectUrls } from '../selectors/appRuntimeReader';
export const validateRedirectUrl = _ref => {
  let {
    app,
    redirectUrl
  } = _ref;
  const acceptedRedirectUrls = getAppRedirectUrls(app);
  return acceptedRedirectUrls.includes(redirectUrl);
};
const INSTALL_STATUSES = ['getPlatform', 'tokenReceived', 'close', 'close-in-ejs'];
export const validatePostMessageInstallStatus = event => INSTALL_STATUSES.includes(event.data.installStatus);
//# sourceMappingURL=oauth-validations.js.map